import React from "react";

export const NumberInput = ({
  min,
  max,
  integerOnly,
  positiveOnly,
  blockScientificNotation = true, //block entry of the letter e to denote scientific notation by default
  value,
  onChange,
  decimalPrecision = 2, //allow only 2 decimal places by default
  floor,
  ...props
}) => {
  const handleChange = (e) => {
    const parsedMin = parseFloat(min);
    const parsedMax = parseFloat(max);
    if (e.target.value === "") {
      onChange(e);
    } else {
      let parsedValue = parseFloat(e.target.value);

      //this is to make it so they can't type more than a certain amount of decimals but
      //they both jump to end of input
      //the first one prevents them from copy pasting numbers with more decimals than the allowed precision
      //but i'd rather it round on copy and paste like the second implementation
      //however the second one makes anything they type after the . function like insert has been pressed on the keyboard
      //and has other buggy behavior, erasing the dot makes it jump to the beginning of the input
      //entering a number 5 and above at the end causes the number before to round up instead of doing nothing
      //etc
      if (e.target.value.split(".")[1]?.length > decimalPrecision) {
        return;
      }
      //---------------------------------------------
      //   if (decimalPrecision) {
      //     parsedValue = parseFloat(parsedValue.toFixed(decimalPrecision));
      //     e.target.value = parsedValue;
      //   }
      if (parsedValue > parsedMax) {
        e.target.value = parsedMax;
        onChange(e);
      } else if (parsedValue < 0 && positiveOnly) {
        // added to handle when user uses the arrow keys built into number inputs to lower value while at 0. (Previously only blocked "-" on key down )
        e.target.value = 0;
      } else if (parsedValue < parsedMin) {
        if (floor) {
          e.target.value = parsedMin;
        }
        onChange(e);
      } else {
        onChange(e);
      }
    }
  };
  const handleKeyDown = (e) => {
    integerOnly && e.key === "." && e.preventDefault();
    positiveOnly && e.key === "-" && e.preventDefault();
    blockScientificNotation &&
      (e.key === "e" || e.key === "E") &&
      e.preventDefault();
  };

  return (
    <input
      type="number"
      min={min}
      max={max}
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      {...props}
    />
  );
};
